import {configureStore} from '@reduxjs/toolkit';
import {apiSlice} from './apiSlice';

// Create the Redux store using RTK's configureStore for easy setup
export const store = configureStore({
    // Reducers handle state changes; here we add the API slice reducer for managing API-related state
    reducer:{
        [apiSlice.reducerPath]: apiSlice.reducer,
    },
    // Middleware runs extra logic on actions; RTK Query's middleware handles caching, retries, etc.
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(apiSlice.middleware)
});

// Type for the entire app state (useful for TypeScript)
export type RootState = ReturnType<typeof store.getState>;
// Type for the dispatch function (useful for TypeScript)
export type AppDispatch = typeof store.dispatch;